import "./style.css";
import Alpine from "alpinejs";
import htmx from "htmx.org";
import "flowbite";

window.Alpine = Alpine;
window.htmx = htmx;

Alpine.start();
